angular.module('cvsApp').service('validateDeepLinkService',['networkService', 'xdrService', 'validateDeepLinkModel', 'configManager', function (NS, XS, VDLM, CM) {

    function validateDeepLinkService (){
        this.validateDeepLink = function(callBackSuccess){
            //get url
			var url = CM.getGuestUrlV2('VAL_DEEP_LINK_2', '3.0');
            var request = {url:url,
                header:{"Content-Type":"application/xml"},
                data:getRequestBody(),
                onSuccess:callBackSuccess
            };
            cvsUtility.commonServiceCode(url,"validateDeepLink",VDLM,request,callBackSuccess,NS);

        };


        var getRequestBody = function(){

            var timeStamp=cvsUtility.getTimeStamp();
				// var requestJson = {request:{
				// 				apiKey:cvsUtility.queryMap.apikey,
				// 				timestamp:timeStamp,
				// 				entryKey:cvsUtility.queryMap.accessKey}};
			var requestJson = {"validateLinkRequest":{
                "header": {
                    "serviceContext": {
                        "appName": cvsUtility.queryMap.mobileAppStyle? 'SPL_APP' : 'SPL_WEB',
                        "lineOfBusiness": "Specialty",
                        "serviceCors": "True",
                        "channelName": cvsUtility.queryMap.channel
                    },
                    "securityContext": {
                        "apiKey": cvsUtility.queryMap.apikey
                    }
                },
                "details": {
                    "entryKey": cvsUtility.queryMap.accessKey,
                    "guestFlow" : true
                }
            }};

            return cvsUtility.JSONToXml(requestJson);

        };
    }

    return new validateDeepLinkService();
}]);
